export default {
  opponentRank: {
    rankSummary: "Rang {{rank}} bei {{marketName}}",
    feedSubtitle: "{{team}} DEF-Rang",
  },
};
